import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_KEY;

const storedData = JSON.parse(localStorage.getItem("outletdataLocal")) || {};

    let outletId, outletlogo;
    
    // Check if storedData is an array or an object
    if (Array.isArray(storedData) && storedData.length > 0) {
        outletId = storedData[0].outletId;
        //outletlogo = storedData[0].outletlogo;
    } else if (storedData && typeof storedData === "object") {
        outletId = storedData.outletId;
        //outletlogo = storedData.outletlogo;
    }

    export const apiOutletInfo = async (setOutletInfo) => {
    try {
        const response = await axios.get(`${API_BASE_URL}OutletInfo/GetOutletInfoByOutletId?outletId=${outletId}`)
        setOutletInfo(response.data)


    } catch (error) {
        console.log("Outlet Info Not found", error);
    }
}

const orderid = Number(localStorage.getItem("orderId")) || 0;

export const apiOrderInfo = async (setOrderInfo) => {
    try {
        const response = await axios.get(`${API_BASE_URL}QrOrder/${orderid}/status`)
        setOrderInfo(response.data)


    } catch (error) {
        console.log("Outlet Info Not found", error);
    }
}